import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'vue-cookies';

import common from '@/common/common.js'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        langcur: common.basic.chstr2int(Cookie.get('lang'), 1),
        langdic: common.json.sync('/include/dic2.json'),
        config: common.json.sync('/include/config.json'),
        pngpre: 'data:image/png;base64,',
        parglobal: {},
        logourl: '',
        avatar: '',
        username: '',
        showname: '',
        topnav: 1,
        isfull: true,
        topnavsort: 1,
        islogin: common.basic.chstr2int(Cookie.get('isloginsht')),
        memlev: common.basic.chstr2int(Cookie.get('memlevsht')),
        wh: window.innerHeight,// document.body.clientHeight;
        ww: window.innerWidth// document.body.clientWidth;

    },
    getters: {
        issmall: state => state.ww <= 800
    },
    mutations: {
        SET_ISLOGIN(state, v) {
            if (state.islogin != v) {
                state.islogin = v;
                Cookie.set('isloginsht', v, -1);
            }
        },
        SET_MEMLEV(state, v) {
            if (state.memlev != v) {
                state.memlev = v;
                Cookie.set('memlevsht', v, -1);
            }
        },
        SET_LANGCUR(state, v) {
            if (state.langcur != v) {
                state.langcur = v;
                Cookie.set('lang', v, -1);
            }
        },
        SET_PARGLOBAL(state, v) {
            if (state.parglobal != v) {
                state.parglobal = v;
            }
        },
        SET_LOGOURL(state, v) {
            if (state.logourl != v) {
                state.logourl = v;
            }
        },
        SET_USERNAME(state, v) {
            if (state.username != v) {
                state.username = v;
            }
        },
        SET_SHOWNAME(state, v) {
            if (state.showname != v) {
                state.showname = v;
            }
        },
        SET_AVATAR(state, v) {
            if (state.avatar != v) {
                state.avatar = v;
            }
        },

        SET_WINDOWSIZE(state) {
            state.wh = window.innerHeight;// document.body.clientHeight;
            state.ww = window.innerWidth;// document.body.clientWidth;
        },
        SET_TOPNAV(state, v) {
            if (state.topnav != v) {
                state.topnav = v;
                state.isfull = v >= 100;
                state.topnavsort = state.isfull ? v / 100 : v;
            }

        }
    },
    actions: {
        setislogin({ commit }, v) {
            commit('SET_ISLOGIN', v);
        },
        setmemlev({ commit }, v) {
            commit('SET_MEMLEV', v);
        },
        setlangcur({ commit }, v) {
            commit('SET_LANGCUR', v);
        },
        setparglobal({ commit }, v) {
            commit('SET_PARGLOBAL', v);
        },
        setlogourl({ commit }, v) {
            commit('SET_LOGOURL', v);
        },
        setusername({ commit }, v) {
            commit('SET_USERNAME', v);
        },
        setshowname({ commit }, v) {
            commit('SET_SHOWNAME', v);
        },
        setavatar({ commit }, v) {
            commit('SET_AVATAR', v);
        }
    }
});

export default store;
